export default "__VITE_ASSET__aB10IrtS__"